module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-DemiLight.a55cd74b.woff2";